import { TableDefault } from "@/components/table/table-default";
import { TableHeaderFilter } from "@/components/table/table-header-filter";
import { DataConfig } from "@/components/table/useDefaultDataConfig";
import { useState } from "react";
import { NotificationList } from "@/api/notifications";
import NotificationCustomCol from "./NotificationCustomCol";
import useNotificationSpec from "./utils/useNotificationSpec";

export default function NotificationTable({
  notifications,
  isLoading,
  dataConfig,
  setDataConfig,
}: {
  notifications?: NotificationList;
  isLoading: boolean;
  dataConfig: DataConfig;
  setDataConfig: React.Dispatch<React.SetStateAction<DataConfig>>;
}) {
  const [selectedRow, setSelectedRow] = useState<number[]>([]);
  const spec = useNotificationSpec();

  return (
    <TableDefault
      spec={spec}
      data={
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        notifications as any
      }
      loading={isLoading}
      selectedRow={selectedRow}
      setSelectedRow={setSelectedRow}
      dataConfig={dataConfig}
      setDataConfig={setDataConfig}
      customFilterByColumns={TableHeaderFilter}
      customCell={NotificationCustomCol}
      searchFilterByColumns
      hideActionColumn
    />
  );
}
